"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserDivisionAccordionExpanded = isUserDivisionAccordionExpanded;
exports.isUserFlightAccordionExpanded = isUserFlightAccordionExpanded;
exports.resolveUserDivisionFlight = resolveUserDivisionFlight;
/** Returns true when a division accordion should start expanded for this user. */
function isUserDivisionAccordionExpanded(divisionName, userDivision, scoreCode) {
    // No score code (TB organizer view, public leaderboard) — show all divisions expanded.
    if (!scoreCode) {
        return true;
    }
    if (userDivision) {
        return divisionName === userDivision;
    }
    return divisionName === 'Unassigned';
}
/** Returns true when a nested flight accordion should start expanded for this user. */
function isUserFlightAccordionExpanded(flightName, userFlight, scoreCode) {
    // No score code (TB organizer view, public leaderboard) — show all flights expanded.
    if (!scoreCode) {
        return true;
    }
    if (userFlight) {
        return flightName === userFlight;
    }
    return flightName === 'Unassigned';
}
/**
 * Resolves the current user's division and flight from registration or leaderboard rows.
 */
function resolveUserDivisionFlight(scoreCode, registrationData, leaderboardData) {
    if (!scoreCode) {
        return { division: null, flight: null };
    }
    const registration = registrationData?.find((row) => row.scoreCode === scoreCode);
    if (registration?.division || registration?.flight) {
        return {
            division: registration.division ?? null,
            flight: registration.flight ?? null,
        };
    }
    const leaderboardRow = leaderboardData?.find((row) => row.playerScoreCode === scoreCode);
    const playerInfo = leaderboardRow?.playerInfo?.[0];
    if (playerInfo?.division || playerInfo?.flight) {
        return {
            division: playerInfo.division ?? null,
            flight: playerInfo.flight ?? null,
        };
    }
    return { division: null, flight: null };
}
